<template>
    <div>
        <div>
            <v-col cols="12" xl="10">
                <v-row>
                    <v-col cols="12" lg="4" class="py-0">
                        <b-input
                            to-mutate="patients::patient.diagnosis.diagnosis"
                            :label="t('patients::form.label.diagnosis')"
                            :rules="validationRules.diagnosis"
                            mandatory
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="py-0">
                        <b-input
                            to-mutate="patients::patient.diagnosis.previous_anti_psychotics"
                            :label="t('patients::form.label.previous_anti_psychotics')"
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="py-0">
                        <b-input
                            to-mutate="patients::patient.diagnosis.ward_name"
                            :label="t('patients::form.label.ward_name')"
                            :rules="validationRules.ward_name"
                        ></b-input>
                    </v-col>
                </v-row>
            </v-col>
        </div>

        <div>
            <v-col cols="12" xl="10">
                <v-row>
                    <v-col cols="12" lg="4" class="pb-0">
                        <b-switch
                            to-mutate="patients::patient.diagnosis.is_prescribed_clozapine"
                            :label="t('patients::form.label.prescribed_clozapine')"
                        ></b-switch>
                    </v-col>
                    <!-- 1 -->
                    <v-col cols="12" lg="4" class="pb-0">
                        <b-switch
                            to-mutate="patients::patient.diagnosis.is_with_sch"
                            :label="t('patients::form.label.has_sch')"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="py-0">
                        <b-switch
                            to-mutate="patients::patient.diagnosis.is_chemo_or_observation"
                            :label="t('patients::form.label.special_observation')"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <b-switch
                            to-mutate="patients::patient.diagnosis.is_under_monitoring"
                            :label="t('patients::form.label.special_monitoring')"
                        ></b-switch>
                    </v-col>
                    <!-- 2 -->
                    <v-col cols="12" lg="4">
                        <b-switch
                            to-mutate="patients::patient.diagnosis.is_with_park"
                            :label="t('patients::form.label.has_park')"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <b-switch
                            to-mutate="patients::patient.diagnosis.is_with_bone_disease"
                            :label="t('patients::form.label.bone_disease')"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="py-0">
                        <b-switch
                            to-mutate="patients::patient.diagnosis.is_in_patient"
                            :label="t('patients::form.label.treatment_place')"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="3" class="pb-0">
                        <b-switch
                            class="switch"
                            to-mutate="patients::patient.diagnosis.suspension"
                            :label="t('patients::form.label.denzapine_suspension')"
                        ></b-switch>
                    </v-col>
                </v-row>
            </v-col>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            validationRules: {
                diagnosis: [(v) => !!v || t('users::validation.field.required')],
                previous_anti_psychotics: [(v) => !!v || t('users::validation.field.required')],
                ward_name: [],
            },
        };
    },
};
</script>

<style></style>
